import { BENCHMARK, COL_BENCHMARK } from "./field/benchmark";
import { PROPERTY_TYPE, COL_PROPERTY_TYPE } from "./field/property_type";
import { CLEAR_BUTTON, SUBMIT_BUTTON, COL_CLEAR_SUBMIT_BUTTON } from "./field/button";

const getSearchFields = () => {

  return [
    BENCHMARK,
    PROPERTY_TYPE,
  ];

}

const getSearchFormConfig = ({ search_type }) => {

  const MOBILE_FORM = [
    {
      id: "row_1",
      type: "row",
      props: {
        className: "gy-2 d-flex flex-fill"
      },
      children: [
        COL_BENCHMARK,
        COL_PROPERTY_TYPE,
      ]
    },
    {
      id: "row_2",
      type: "row",
      props: {
        className: "gy-2 d-flex flex-fill"
      },
      children: [
        COL_CLEAR_SUBMIT_BUTTON
      ]
    }
  ];

  const DESKTOP_FORM = [
    {
      id: "row_1",
      type: "row",
      props: {
        className: "gy-2 d-flex flex-fill"
      },
      children: [
        COL_BENCHMARK,
        COL_PROPERTY_TYPE,
      ]
    },
    {
      id: "row_2",
      type: "row",
      props: {
        className: "gy-2 d-flex flex-fill"
      },
      children: [
        COL_CLEAR_SUBMIT_BUTTON
      ]
    }
  ];

  const MOBILE = {
    id: "mobile",
    type: "div",
    props: {
      className: "d-flex flex-column d-sm-none mobile"
    },
    children: MOBILE_FORM
  };

  const DESKTOP = {
    id: "desktop",
    type: "div",
    props: {
      className: "d-none d-sm-flex flex-column desktop"
    },
    children: DESKTOP_FORM
  };

  // TODO: Hook here

  return [{
    id: "form",
    type: "div",
    children: [
      MOBILE,
      DESKTOP
    ]
  }];

}

export { getSearchFields, getSearchFormConfig };
